import ActionChip from "../ActionChip";
import ActiveSwitch from "../ActiveSwitch";
import CustomCheckbox from "../CustomCheckbox";
import GraphButton from "../GraphButton";
import CheckboxHeader from "../Header/CheckboxHeader";
import ContributionSalesHeader from "../Header/ContributionSalesHeader";
import DailybudgetHeader from "../Header/DailybudgetHeader";
import DailyGapConsumedHeader from "../Header/DailyGapConsumedHeader";
import MeliStatusHeader from "../Header/MeliStatusHeader";
import MonthlyGapConsumedHeader from "../Header/MonthlyGapConsumedHeader";
import RoasobjectiveHeader from "../Header/RoasobjectiveHeader";
import MeliStatus from "../MeliStatus";
import AdStateChip from "../AdStateChip";
import CpcCell from "../CpcCell";
import CvrCell from "../CvrCell";
import RoasCell from "../RoasCell";
import AcosCell from "../Acos.Cell";
import ContributionSalesCell from "../ContributionSalesCell";
import GapCosumedCell from "../GapCosumedCell";
import CampaignNameCell from "../CampaignNameCell";
import RecommendationCell from "../RecomendationCell";
import CmColumnNumberField from "../CmColumnNumberField";
import EditCmNumberInput from "../EditCmNumberInput";

export const getRowId = (row) => row.id;

export const tableStyles = {
  "& .MuiDataGrid-cell": {
    borderBottom: "1px solid #E0E0E0",
  },

  "& .border-right": {
    borderRight: "1px solid #E0E0E0",
  },
  "& .border-bottom": {
    borderBottom: "1px solid #E0E0E0",
  },
  "& .MuiDataGrid-columnHeader--emptyGroup": {
    borderBottom: "1px solid #E0E0E0",
  },
  "& .header": {
    backgroundColor: "#f3f4f6",
  },
  "& .header-special": {
    backgroundColor: "#e2e8f0",
  },
  "& .cell-special": {
    backgroundColor: "#f1f5f9",
  },
  "& .editable": {
    color: "rgba(0, 0, 0, 0.38)",
  },
  "& .MuiDataGrid-scrollbar--vertical": {
    display: "none",
  },
  "& .MuiDataGrid-filler": {
    height: "fit-content !important",
  },
  "& .MuiDataGrid-main": {
    paddingBottom: "16px !important",
  },
  "& .no-padding": {
    padding: "0 !important",
  },
  "& .cell-cat": {
    backgroundColor: "#FFE0B2 !important",
  },
  "& .cell-hij": {
    backgroundColor: "#f9cfcf !important",
  },
  "& .triangle-top-left-cat": {
    width: "0",
    height: "0",
    borderBottom: "16px solid transparent",
    borderLeft: "16px solid orange",
  },
  "& .triangle-top-left-error": {
    width: "0",
    height: "0",
    borderBottom: "16px solid transparent",
    borderLeft: "16px solid red",
  },
  "& .triangle-bottom-left-error": {
    width: "0",
    height: "0",
    borderTop: "16px solid transparent",
    borderLeft: "16px solid red",
  },
  "& .MuiToolbar-root": {
    padding: "0 !important",
  },

  height: "calc(100vh - 325px)",
  // height: '100%',
};

export const timeRangeOptions = [
  {
    value: "today",
    label: "Hoy",
  },
  {
    value: "yesterday",
    label: "Ayer",
  },
  {
    value: "todayAndYesterday",
    label: "Hoy y ayer",
  },
  {
    value: "last7Days",
    label: "Últimos 7 días",
  },
  {
    value: "last14Days",
    label: "Últimos 14 días",
  },
  {
    value: "last30Days",
    label: "Últimos 30 días",
  },
  {
    value: "last45Days",
    label: "Últimos 45 días",
  },
  {
    value: "lastWeek",
    label: "Última semana",
  },
  {
    value: "lastMonth",
    label: "Último mes",
  },
  {
    value: "custom",
    label: "Personalizado",
  },
];

export const columns = [
  {
    // ...GRID_CHECKBOX_SELECTION_COL_DEF,
    field: "checkbox",
    headerName: "Checkbox",
    renderHeader: () => <CheckboxHeader />,
    renderCell: (params) => <CustomCheckbox row={params.row} />,
    headerClassName: "header border-bottom",
    width: 62,
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "active",
    headerName: "Activa",
    headerClassName: "header border-bottom",
    renderCell: (params) => <ActiveSwitch active={params.row.active} />,
    minWidth: 62,
    flex: 0.5,
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "campaignName",
    headerName: "Campaña",
    headerClassName: "header border-bottom",
    renderCell: (params) => <CampaignNameCell row={params.row} />,
    minWidth: 230,
    flex: 2,
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },

  {
    field: "graph",
    headerName: "Grafico",
    renderCell: (params) => <GraphButton row={params.row} />,
    headerClassName: "header border-bottom",
    minWidth: 70,
    flex: 0.5,
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "adState",
    headerName: "Ad State",
    headerClassName: "header border-bottom",
    minWidth: 130,
    renderCell: (params) => <AdStateChip adState={params.row.adState} />,
    flex: 0.8,
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "dailyBudget",
    headerName: "Presupuesto diario",
    headerClassName: "header border-bottom",
    renderHeader: () => <DailybudgetHeader />,
    renderCell: (params) => (
      <CmColumnNumberField
        id={params.id}
        field="dailyBudget"
        prefix="$"
        row={params.row}
      />
    ),
    renderEditCell: (params) => (
      <EditCmNumberInput
        {...params}
        prefix="$"
        thousandSeparator={true}
        decimalScale={2}
      />
    ),
    editable: true,
    minWidth: 100,
    flex: 1,
    resizable: false,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "targetRoas",
    headerName: "ROAS Objetivo",
    headerClassName: "header border-bottom",
    renderHeader: () => <RoasobjectiveHeader />,
    renderCell: (params) => (
      <CmColumnNumberField
        id={params.id}
        field="targetRoas"
        suffix="x"
        row={params.row}
      />
    ),
    renderEditCell: (params) => (
      <EditCmNumberInput
        {...params}
        suffix="x"
        thousandSeparator={false}
        decimalScale={2}
      />
    ),
    editable: true,
    minWidth: 80,
    flex: 1,
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "gapConsumed",
    headerName: "% GAP Consumido mensual",
    headerClassName: "header border-bottom",
    renderHeader: () => <MonthlyGapConsumedHeader />,
    renderCell: (params) => (
      <GapCosumedCell gapConsumed={params.row.gapConsumed} />
    ),
    minWidth: 230,
    flex: 2.5,
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "dailygapconsumed",
    headerName: "% GAP Consumido diario",
    headerClassName: "border-bottom header",
    renderHeader: () => <DailyGapConsumedHeader />,
    renderCell: (params) => (
      <GapCosumedCell gapConsumed={params.row.dailyGapConsumed} />
    ),
    minWidth: 230,
    flex: 2.5,
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "cpc",
    headerName: "CPC",
    headerClassName: "header border-bottom",
    renderCell: (params) => <CpcCell cpc={params.row?.cpc} />,
    minWidth: 100,
    flex: 1,
    type: "number",
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "cvr",
    headerName: "CVR",
    headerClassName: "header border-bottom",
    renderCell: (params) => <CvrCell cvr={params.row?.cvr} />,
    minWidth: 80,
    flex: 1,
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "salesContribution",
    headerName: "Contribución de ventas",
    renderHeader: () => <ContributionSalesHeader />,
    renderCell: (params) => (
      <ContributionSalesCell
        ads={params.row?.salesContribution.adsPercentage}
        organic={params.row?.salesContribution.organicPercentage}
      />
    ),
    headerClassName: "header border-bottom",
    minWidth: 140,
    flex: 2,
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "roas",
    headerName: "ROAS",
    type: "number",
    renderCell: (params) => <RoasCell roas={params.row?.roas} />,
    headerClassName: "header border-bottom",
    minWidth: 80,
    flex: 0.5,
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "acos",
    headerName: "ACOS",
    headerClassName: "header border-bottom",
    renderCell: (params) => <AcosCell acos={params.row?.acos} />,
    type: "number",
    minWidth: 80,
    flex: 0.5,
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "recommendation",
    headerName: "Recomendación",
    headerClassName: "header border-bottom",
    minWidth: 280,
    renderCell: (params) => (
      <RecommendationCell recomendation={params?.row.recomendation} />
    ),
    flex: 4,
    resizable: false,
    sortable: false,
    headerAlign: "center",

    align: "center",
  },
  {
    field: "action",
    headerName: "Acción",
    headerClassName: "header border-bottom",
    renderCell: (params) => <ActionChip action={"Modificar"} />,
    minWidth: 90,
    flex: 0.5,
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "feedback",
    headerName: "MELI Status",
    renderHeader: () => <MeliStatusHeader />,
    renderCell: (params) => <MeliStatus row={params.row} />,
    headerClassName: "header border-bottom",
    cellClassName: "",
    minWidth: 80,
    flex: 0.5,
    resizable: false,
    sortable: false,
    headerAlign: "center",
    align: "center",
  },
];
